import React, { useEffect, useState } from "react";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import Paper from "@material-ui/core/Paper";
import { getMyEventsAction, deleteMissionAction } from "store/actions";
import { connect } from "react-redux";
import get from "lodash/get";
import { Link } from "react-router-dom";
import Button from "@material-ui/core/Button";
import styled from "styled-components";
import { formatDate } from "utils";
import ConfirmationModal from "components/modify/ConfirmationModal";

export const MyEventsPage = ({ getMyEvents, myEvents, deleteMission }) => {
  useEffect(() => {
    getMyEvents();
  }, [getMyEvents]);

  const [deleteModalOpen, setDeleteModalOpen] = useState(false);
  const [deleteEventID, setDeleteEventID] = useState();

  return (
    <Wrapper>
      <TableContainer component={Paper}>
        <Table aria-label="simple table">
          <TableHead>
            <TableRow>
              <TableCell>Event ID</TableCell>
              <TableCell>Name</TableCell>
              <TableCell>Date</TableCell>
              <TableCell>Owner</TableCell>
              <TableCell>Repo</TableCell>
              <TableCell />
              <TableCell />
            </TableRow>
          </TableHead>
          <TableBody>
            {myEvents.map(
              ({
                event_id,
                event_title,
                event_date,
                event_owner,
                event_repo,
              }) => (
                <TableRow key={event_id}>
                  <TableCell component="th" scope="row">
                    {event_id}
                  </TableCell>
                  <TableCell>{event_title}</TableCell>
                  <TableCell>{formatDate({ date: event_date })}</TableCell>
                  <TableCell>{event_owner}</TableCell>
                  <TableCell>{event_repo}</TableCell>
                  <TableCell>
                    <Link to={`/raffle/${event_id}`}>
                      <Button
                        id={"raffleButton"}
                        variant="contained"
                        color="primary"
                      >
                        Raffles
                      </Button>
                    </Link>
                  </TableCell>
                  <TableCell>
                    <Link to={`/events/${event_id}`}>
                      <Button
                        id={"eventButton"}
                        variant="contained"
                        color="primary"
                      >
                        View
                      </Button>
                    </Link>
                  </TableCell>
                  <TableCell>
                    <Link to={`/edit/${event_id}`}>
                      <Button
                        id={"editButton"}
                        variant="contained"
                        color="primary"
                      >
                        Edit
                      </Button>
                    </Link>
                  </TableCell>
                  <TableCell>
                    <Button
                      id={"deleteEventButton"}
                      variant="contained"
                      color="secondary"
                      onClick={() => {
                        setDeleteModalOpen(true);
                        setDeleteEventID(event_id);
                      }}
                    >
                      Delete
                    </Button>
                  </TableCell>
                </TableRow>
              )
            )}
          </TableBody>
        </Table>
      </TableContainer>
      <ConfirmationModal
        isOpen={deleteModalOpen}
        setIsOpen={setDeleteModalOpen}
        mainBodyText={
          <div>
            Are you sure you want to delete this mission?{"\n"}
            <i>This cannot be undone.</i>
          </div>
        }
        onClickYes={() => {
          deleteMission(deleteEventID);
          setDeleteModalOpen(false);
        }}
        onClickNo={() => setDeleteModalOpen(false)}
      />
    </Wrapper>
  );
};

//Adding overflow for now
//should add pagination/searching
//in the future
const Wrapper = styled.div`
  width: 80%;
  align-self: center;
  height: 85%;
  overflow: auto;
`;

export const mapStateToProps = (state) => ({
  myEvents: get(state, "rootReducer.orbat.myEvents.events", []),
});

const mapDispatchToProps = {
  getMyEvents: getMyEventsAction,
  deleteMission: deleteMissionAction,
};

export default connect(mapStateToProps, mapDispatchToProps)(MyEventsPage);
